// SVG icon components for glyphs that are absent from Android system fonts.
// Use these instead of raw Unicode codepoints from the Dingbats or
// Miscellaneous Mathematical Symbols blocks (e.g. ✦ U+2726, ⧗ U+29D7).

export function StarIcon({ className, style }: { className?: string; style?: React.CSSProperties }) {
  return (
    <svg
      className={className}
      style={style}
      viewBox="0 0 16 16"
      fill="currentColor"
      aria-hidden
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Four-pointed star (✦ U+2726 analogue) */}
      <path d="M8 0 L9.77 6.23 L16 8 L9.77 9.77 L8 16 L6.23 9.77 L0 8 L6.23 6.23 Z" />
    </svg>
  )
}

export function SleepIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 16 16"
      fill="currentColor"
      aria-hidden
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Crescent moon (⏾ U+23FE analogue) */}
      <path d="M8 1a7 7 0 1 0 7 7A5.5 5.5 0 0 1 8 2.5 5.5 5.5 0 0 1 5.5 1 7 7 0 0 0 8 1z" />
    </svg>
  )
}
